export default __webpack_public_path__ + "static/media/mic-active-grey.97cc7002.svg";